import React from "react";
import SVG from "react-inlinesvg";
import {
  convertMinutesToHours,
  iconPath,
} from "../../../../constants/constants";
import { PaginationBar } from "../../../../components/sharedComponents/PaginationBar";
import { useIntl } from "react-intl";
import { Else, If, Then } from "react-if";

export const Packages = ({
  mentorData,
  itemServices,
  handlePageChange,
  handleNavigation,
}) => {
  const path = iconPath();
  const { messages } = useIntl();

  console.log(itemServices);

  return (
    <div className="row">
      {itemServices?.data.map((service, index) => (
        <div className="col-lg-4 col-md-6" key={index}>
          <div className="book_ment_view">
            <h3 onClick={() => handleNavigation(service?.id)}>
              {service?.title}
            </h3>
            <p className="service-data--info">{service?.description}</p>
            <ul>
              <li>
                <SVG src={`${path}p1.svg`} />
                {service?.priceWTax} {messages["SAR"]}
                <span>
                  {mentorData?.vat_included
                    ? "(" + messages["vat_included"] + ")"
                    : ""}
                </span>
              </li>
              <li>
                <SVG src={`${path}p2.svg`} />{" "}
                {convertMinutesToHours(service?.period)}
                {messages["hour"]} - {messages["with_serivce_num"]} (
                {service?.package_session_number}) {messages["session"]}
              </li>
              <li>
                <SVG src={`${path}b3.svg`} /> {messages["package_validity"]} (
                {service?.package_validity} {messages["month"]})
              </li>
            </ul>
            <button
              className="btn btn_booking w-100"
              onClick={() => handleNavigation(service?.id, "package")}
            >
              {messages["book_session"]}
            </button>
          </div>
        </div>
      ))}

      <div className="col-12 d-flex justify-content-center mt-3">
        <PaginationBar
          totalPages={itemServices?.last_page}
          currentPage={itemServices?.current_page}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};
